import React from 'react'
import { Skeleton } from 'antd'

import layout from './ProjectHealthDashboard.module.css'
import sk from './ReportSkeleton.module.css'

const MemberHealthCardSkeleton = () => (
    <div className={layout.memberCard} aria-hidden>
        <div
            className={`${layout.memberCardHeader} ${sk.memberCardHeaderStatic}`}
        >
            <div className={layout.memberIdentity}>
                <Skeleton.Avatar active size={40} />
                <div className={layout.memberMeta}>
                    <Skeleton.Input active className={sk.memberNameSk} />
                    <Skeleton.Input active className={sk.memberSubSk} />
                </div>
            </div>
            <div className={layout.memberStats}>
                {[0, 1, 2].map((i) => (
                    <div key={i} className={layout.memberStat}>
                        <Skeleton.Input
                            active
                            className={sk.memberStatLabelSk}
                        />
                        <Skeleton.Input
                            active
                            className={sk.memberStatValueSk}
                        />
                    </div>
                ))}
                <div className={layout.memberProgressWrap}>
                    <Skeleton.Input active className={sk.memberProgressSk} />
                    <Skeleton.Input active className={sk.memberPercentSk} />
                </div>
            </div>
            <Skeleton.Avatar
                active
                shape="circle"
                className={sk.memberChevronSk}
            />
        </div>
    </div>
)

export default MemberHealthCardSkeleton
